// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@supports (animation-range: entry-crossing) {
  .fit-container {
    width: 230px;
    font-size: 1rem;
    overflow: hidden;
    scroll-snap-type: both mandatory;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
  }
  .fit-container > * {
    inline-size: max-content;
    line-height: 1;
    transform-origin: 0 0;
    animation: apply-text-ratio linear;
    animation-timeline: view(inline);
    animation-range: entry-crossing;
    display: block;
    scroll-snap-align: start;
    contain: layout;
  }
}
@keyframes apply-text-ratio {
  from {
    transform: scale(0);
    margin-block-end: -1lh;
  }
}
@supports not (animation-range: entry-crossing) {
  .fit-container * {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 230px;
    display: inline-block !important;
  }
}
:host {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.org-card {
  height: 172px;
  padding-top: 30px;
  overflow: visible;
  display: flex;
  flex-direction: column;
}
.org-card.staff .highlight-container {
  border-radius: 34px;
}
.org-card .highlight-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  transition: 0.5 ease-out;
}
.org-card .highlight-container.selected {
  border: 4px solid var(--gc-color-primary);
  margin: -4px;
}
.org-card .highlight-container.highlighted:not(.selected) {
  box-shadow: 0px 0 20px 0px var(--gc-color-primary);
}
.org-card.user .org-card-inner {
  border-left: 0.5rem solid var(--orgchart-card-border, #3AB6E3);
  border-right: 0.5rem solid var(--orgchart-card-border, #3AB6E3);
}
.org-card.user .org-card-person {
  flex-grow: 1;
  align-items: center;
}
.org-card.staff .org-card-inner {
  border-radius: 30px;
}
.org-card.staff .org-card-department {
  font-weight: normal;
  font-size: 1rem;
}
.org-card.staff .org-card-children {
  bottom: 0.5rem;
  left: 1rem;
  right: 1rem;
}
.org-card.department .org-card-inner {
  border-top: 30px solid var(--orgchart-card-border, #3AB6E3);
}
.org-card.department .org-card-inner > .org-card-image {
  top: -60px;
}
.org-card.department .org-card-department {
  margin-top: 0.25rem;
  min-height: 34px;
}
.org-card-inner {
  flex-grow: 1;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  background-color: var(--gc-background-color);
  border: 1px solid var(--gc-border-color);
}
.org-card-inner > .org-card-image {
  overflow: hidden;
  position: absolute;
  top: -2rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--orgchart-card-border);
}
.org-card-department {
  height: 1.5rem;
  font-weight: bold;
  font-size: 1.25rem;
  margin-top: 33px;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: flex-end;
}
.org-card-person {
  display: flex;
  align-items: flex-start;
  height: 2.5rem;
  font-size: 1rem;
  text-align: center;
}
.org-card-person v-user {
  font-weight: bold;
  display: flex !important;
  justify-content: center;
}
.org-card-person .org-card-name {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.org-card-children {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  align-items: flex-end;
}

.expand-button {
  border: 1px solid var(--gc-border-color);
  border-radius: 3px;
  padding: 5px;
  margin: auto auto;
  background-color: var(--gc-background-color);
  display: flex;
}
.expand-button v-icon {
  margin-right: 3px;
}

v-icon.error {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-org-chart/v-org-chart.component.sass"],"names":[],"mappings":"AAMA;EACI;IACI,YAAA;IACA,eAAA;IACA,gBAAA;IACA,gCAAA;IACA,aAAA;IACA,eAAA;IACA,sBAAA;IACA,mBAAA;EALN;EAMM;IACI,wBAAA;IACA,cAAA;IACA,qBAAA;IACA,kCAAA;IACA,gCAAA;IACA,+BAAA;IACA,cAAA;IACA,wBAAA;IACA,eAAA;EAJV;AACF;AAIA;EACI;IACI,mBAAA;IACA,sBAAA;EAFN;AACF;AAEA;EAEQ;IACI,uBAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;IACA,gCAAA;EADV;AACF;AAEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAAJ;;AAEA;EACI,aA9CK;EA+CL,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACQ;EACI,mBAAA;AACZ;AAAI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;AAER;AADQ;EACI,yCAAA;EACA,YAAA;AAGZ;AAFQ;EACI,kDAAA;AAIZ;AAFQ;EACI,8DAAA;EACA,+DAAA;AAIZ;AAHQ;EACI,YAAA;EACA,mBAAA;AAKZ;AADQ;EACI,mBAAA;AAGZ;AAFQ;EACI,mBAAA;EACA,eAAA;AAIZ;AAHQ;EACI,cAAA;EACA,UAAA;EACA,WAAA;AAKZ;AAFQ;EACI,2DAAA;AAIZ;AAHY;EACI,UAAA;AAKhB;AAJQ;EACI,mBAAA;EACA,gBAAA;AAMZ;AAJI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,4CAAA;EACA,wCAAA;AAMR;AALQ;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAxGA;EAyGA,YAzGA;EA0GA,kBAAA;EACA,6CAAA;AAOZ;AANI;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EAEA,aAAA;EACA,qBAAA;AAOR;AANI;EACI,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAQR;AAPQ;EACI,iBAAA;EACA,wBAAA;EACA,uBAAA;AASZ;AARQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAUZ;AATI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAWR;;AATA;EACI,wCAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,4CAAA;EACA,aAAA;AAYJ;AAXI;EACI,iBAAA;AAaR;;AAXA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;AAcJ","sourcesContent":["$width: 175px\n$height: 172px\n$imageSize: 60px\n\n// Allow text-font to scale with container\n// based on https://kizu.dev/fit-to-width-text/\n@supports (animation-range: entry-crossing)\n    .fit-container\n        width: 230px\n        font-size: 1rem\n        overflow: hidden\n        scroll-snap-type: both mandatory\n        display: flex\n        flex-wrap: wrap\n        flex-direction: column\n        align-items: center\n        & > *\n            inline-size: max-content\n            line-height: 1\n            transform-origin: 0 0\n            animation:  apply-text-ratio linear\n            animation-timeline: view(inline)\n            animation-range: entry-crossing\n            display: block\n            scroll-snap-align: start\n            contain: layout\n@keyframes apply-text-ratio\n    from\n        transform: scale(0)\n        margin-block-end: -1lh   \n@supports (not (animation-range: entry-crossing))\n    .fit-container\n        * \n            text-overflow: ellipsis\n            overflow: hidden\n            white-space: nowrap\n            width: 230px\n            display: inline-block !important\n\n:host\n    position: absolute\n    top: 0 \n    left: 0\n    right: 0\n    bottom: 0\n\n.org-card\n    height: $height\n    padding-top: calc($imageSize / 2)\n    overflow: visible\n    display: flex\n    flex-direction: column\n    &.staff\n        .highlight-container\n            border-radius: 34px\n    .highlight-container\n        display: flex\n        flex-direction: column\n        flex-grow: 1\n        transition: 0.5 ease-out\n        &.selected\n            border: 4px solid var(--gc-color-primary)\n            margin: -4px\n        &.highlighted:not(.selected)\n            box-shadow: 0px 0 20px 0px var(--gc-color-primary)\n    &.user\n        .org-card-inner\n            border-left: 0.5rem solid var(--orgchart-card-border, #3AB6E3)\n            border-right: 0.5rem solid var(--orgchart-card-border, #3AB6E3)\n        .org-card-person\n            flex-grow: 1\n            align-items: center\n\n\n    &.staff\n        .org-card-inner\n            border-radius: 30px\n        .org-card-department\n            font-weight: normal\n            font-size: 1rem\n        .org-card-children\n            bottom: 0.5rem\n            left: 1rem\n            right: 1rem\n\n    &.department\n        .org-card-inner\n            border-top: calc($imageSize / 2) solid var(--orgchart-card-border, #3AB6E3)\n            > .org-card-image\n                top: -$imageSize\n        .org-card-department\n            margin-top: 0.25rem\n            min-height: 34px\n\n    &-inner\n        flex-grow: 1\n        display: flex\n        position: relative\n        flex-direction: column\n        align-items: center\n        background-color: var(--gc-background-color)\n        border: 1px solid var(--gc-border-color)\n        > .org-card-image\n            overflow: hidden\n            position: absolute\n            top: -2rem\n            width: $imageSize\n            height: $imageSize\n            border-radius: 50%\n            background-color: var(--orgchart-card-border)\n    &-department\n        height: 1.5rem\n        font-weight: bold\n        font-size: 1.25rem\n        margin-top: 33px\n        margin-bottom: 0.4rem\n\n        display: flex\n        align-items: flex-end\n    &-person\n        display: flex\n        align-items: flex-start\n        height: 2.5rem\n        font-size: 1rem\n        text-align: center\n        v-user\n            font-weight: bold\n            display: flex !important\n            justify-content: center\n        .org-card-name\n            display: flex\n            flex-direction: column\n            gap: 0.25rem\n    &-children\n        position: absolute\n        bottom: 0.5rem\n        left: 0.5rem\n        right: 0.5rem\n        display: flex\n        justify-content: space-between\n        align-self: stretch\n        align-items: flex-end\n\n.expand-button\n    border: 1px solid var(--gc-border-color)\n    border-radius: 3px\n    padding: 5px\n    margin: auto auto\n    background-color: var(--gc-background-color)\n    display: flex\n    v-icon\n        margin-right: 3px\n\nv-icon.error\n    position: absolute\n    top: 0.5rem\n    right: 0.5rem"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
